export default __webpack_public_path__ + "static/media/ChatX.9989b19f.svg";